import { registerClientReference } from "react-server-dom-turbopack/server.edge";
export const StoreProvider = registerClientReference(
    function() { throw new Error("Attempted to call StoreProvider() from the server but StoreProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/lib/storeprovider.tsx",
    "StoreProvider",
);
